<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div>
  <div class="addRestoMainContainer container">
    <div class="restoHeadText">Restaurants Details</div>
    <div style="padding:0 20px">
      <form #editResto="ngForm">
        <div class="grid">
          <div class="input-container">
            <label for="restoName">Restaurant Name<span class="starReq">*</span></label>
            <input type="text" name="restoName" placeholder="enter the restaurant name" class="form-control"
              [(ngModel)]="restoEditName" required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="reqAlert">Name is required</div>
          </div>

          <div class="input-container">
            <label for="emailId">Email ID<span class="starReq">*</span></label>
            <input type="text" name="emailId" placeholder="enter the email-id" class="form-control"
              [(ngModel)]="restoEditEmail" #email="ngModel" required />
            <div *ngIf="email.invalid && (email.dirty || email.touched)" class="reqAlert">Email is required</div>
          </div>

          <div class="input-container">
            <label for="restoName">Restaurant Telephone<span class="starReq">*</span></label>
            <input type="text"  placeholder="enter restaurant telephone" class="form-control" [(ngModel)]="restoEditPhone"
              name="restoTel" (keypress)="validateNum($event)" #restoTel="ngModel" required />
            <div *ngIf="restoTel.invalid && (restoTel.dirty || restoTel.touched)" class="reqAlert">Telephone is
              required</div>
          </div>
          <div class="input-container">
            <label for="restoName">Restaurant Logo (less than 500kb)<span class="starReq">*</span></label>
            <div>
              <span class="imgPreview"><img [src]="editSrc" alt="" style="width: 44px;" alt="img" /></span>
              <span>
                <input type="file" accept="image/png,image/jpeg" (change)="oneEditImageChange($event,'l2RestoLogo')"
                  #fileInput_image_edit hidden name="imgFile" id="l2RestoLogo"/>
                <button class="uploadBtn" (click)="fileInput_image_edit.click()">
                  <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                </button>
              </span>

            </div>
          </div>
          <div class="input-container">
            <label for="restoName">Restaurant Address<span class="starReq">*</span></label>
            <textarea class="form-control" id="newRrestoAddress" rows="3" [(ngModel)]="restoEditAddress" name="restoAdd"
              #restoAdd="ngModel" required></textarea>
            <div *ngIf="restoAdd.invalid && (restoAdd.dirty || restoAdd.touched)" class="reqAlert">Address is
              required</div>
          </div>
          <!-- <div class="input-container">
              <label for="newRrestoDescription">Restaurant Descriptions</label>
              <textarea class="form-control" id="newRrestoDescription" rows="3" [(ngModel)]="restoDescrip"
                name="rstoDescp"></textarea>
            </div> -->
          <!-- <div class="input-container">
              <label for="pocName">POC Name</label>
              <input type="text" placeholder="enter the POC name" class="form-control" [(ngModel)]="restoEditPocName"
                name="pocName" />
            </div> -->
          <!-- <div class="input-container">
              <label for="pocId">POC ID</label>
              <input type="text" placeholder="enter the POC ID" class="form-control" [(ngModel)]="restoEditPocId"
                name="pocId" />
            </div> -->
          <!-- <div class="input-container">
              <label for="restoLat">Restaurant Latitude<span class="starReq">*</span></label>
              <input type="text" placeholder="enter restaurant latitude" class="form-control"
                [(ngModel)]="restoEditLotitude" name="restoLat" #restoLat="ngModel" required />
              <div *ngIf="restoLat.invalid && (restoLat.dirty || restoLat.touched)" class="reqAlert">Latitude is
                required</div>
            </div> -->
          <!-- <div class="input-container">
              <label for="restoLog">Restaurant Longitude<span class="starReq">*</span></label>
              <input type="text" placeholder="enter restaurant longitude" class="form-control"
                [(ngModel)]="restoEditLogitude" name="restoLog" #restoLog="ngModel" required />
              <div *ngIf="restoLog.invalid && (restoLog.dirty || restoLog.touched)" class="reqAlert">Longitude is
                required</div>
            </div> -->
          <!-- <div class="input-container">
              <label for="serviceCharge">Service Charge (%)</label>
              <input type="text" placeholder="enter service charge" class="form-control"
                [(ngModel)]="restoEditServiceCharge" name="serviceCharge" />
            </div> -->
          <!-- <div class="input-container">
              <label for="spice">Spice Tolerance Level<span class="starReq">*</span></label>
              <select id="spice" class="form-select" [(ngModel)]="spiceEditTol" name="spice" #spice="ngModel"
                required>
                <option value="" selected disabled>spice-rating</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <div *ngIf="spice.invalid && (spice.dirty || spice.touched)" class="reqAlert">Spice Tolerance is
                required</div>
            </div> -->
          <!-- <div class="input-container">
              <label for="restoName">Number Of Tables</label>
              <input type="text" placeholder="enter number of tables" class="form-control" [(ngModel)]="noOfEditTable"
                name="noOfTable" />
            </div> -->
          <!-- <div class="input-container">
              <label for="restoName">Offer Value (%)</label>
              <input type="text" placeholder="enter offer value" name="offerValue" class="form-control"
                [(ngModel)]="editOfferValue" />
            </div> -->
          <div class="input-container">
            <label>Dietary preferences</label>
            <ng-select class="multi-select" [items]="allDieatary" bindLabel="name" bindValue="id" [multiple]="true"
              groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select dietary preferences"
              (change)="onMaterialGroupChange($event)" name="Dietary" [(ngModel)]="selectedDieatry">
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

              </ng-template>
            </ng-select>
          </div>
          <div class="input-container">
            <label>Allergens</label>
            <ng-select class="multi-select" [items]="allAllergens" bindLabel="name" bindValue="id" [multiple]="true"
              groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select allergens"
              (change)="onMaterialGroupChange($event)" name="Allergens" [(ngModel)]="selectedAllegens">

              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

              </ng-template>
            </ng-select>
          </div>
          <div class="input-container">
            <label>Categories</label>
            <ng-select class="multi-select" [items]="allCaategory" bindLabel="name" bindValue="id" [multiple]="true"
              groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select categories"
              (change)="onMaterialGroupChange($event)" name="Categories" [(ngModel)]="selectedCaategory">

              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

              </ng-template>
            </ng-select>
          </div>
          <div class="input-container">
            <label>Cuisines</label>
            <ng-select class="multi-select" [items]="allCuisine" bindLabel="name" bindValue="id" [multiple]="true"
              groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select cuisines"
              (change)="onMaterialGroupChange($event)" name="Cuisines" [(ngModel)]="selectedCuisine">

              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

              </ng-template>
            </ng-select>
          </div>
          <div class="input-container">
            <label for="restoName">Featured image (less than 500kb)<span class="starReq">*</span></label>
            <div style="display: flex;align-items: center;">
              <span class="imgPreview"><img [src]="featureSrc" alt="" /></span>
              <span style="margin-left: 10px;">
                <input type="file" accept="image/png,image/jpeg," (change)="onFeatureImgChange($event,'l2RestoFeatureImg')"
                  #fileInput_feature_image hidden name="imgFile" id="l2RestoFeatureImg"/>
                <button class="uploadBtn" (click)="fileInput_feature_image.click()">
                  <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                </button>
              </span>

            </div>
          </div>
        </div>
        <div class="input-container">
          <label for="">Opening and closing hours</label>
          <div class="bigScreen">
            <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr;grid-gap: 10px;">
              <div class="time-text">Select days</div>
              <div class="time-text">Open timings</div>
              <div class="time-text">Close timings</div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('mondayTime',$event.target)" [checked]="monPrecheck">
                <div class="cuisine-name"> Monday </div>
              </div>
              <div id="mondayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH" name="monOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM" name="monOpenMM" />
                <select class="time-selectOption" [(ngModel)]="monOpenMead" name="monOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="mondayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH" name="monCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM" name="monCloseMM" />
                <select class="time-selectOption" [(ngModel)]="monCloseMead" name="monCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <span (click)="timeClear('mondayTime')" class="clear-timeBtn" *ngIf="mondayClearCondition">Clear</span>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="tuePrecheck">
                <div class="cuisine-name"> Tuesday </div>
              </div>
              <div id="tuesdayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueOpenHH" name="tueOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueOpenMM" name="tueOpenMM" />
                <select class="time-selectOption" [(ngModel)]="tueOpenMead" name="tueOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="tuesdayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH" name="tueCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM" name="tueCloseMM" />
                <select class="time-selectOption" [(ngModel)]="tueCloseMead" name="tueCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <div class="clear-copyDiv">
                  <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                    *ngIf="tuesdayClearCondition">Clear</span>
                  <div
                    *ngIf="tuesdayClearCondition && monOpenHH.length != 0 && monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="tuesdayClearCondition && monOpenHH.length != 0&& monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0 "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('tue')">
                    Copy
                  </button>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('wednesTime',$event.target)" [checked]="wedPrecheck">
                <div class="cuisine-name"> Wednesday </div>
              </div>
              <div id="wednesTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedOpenHH" name="wedOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedOpenMM" name="wedOpenMM" />
                <select class="time-selectOption" [(ngModel)]="wedOpenMead" name="wedOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="wednesTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH" name="wedCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM" name="wedCloseMM" />
                <select class="time-selectOption" [(ngModel)]="wedCloseMead" name="wedCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <div class="clear-copyDiv">
                  <span (click)="timeClear('wednesTime')" class="clear-timeBtn"
                    *ngIf="wednesdayClearCondition">Clear</span>
                  <div
                    *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0   "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('wed')">
                    Copy
                  </button>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="thurPrecheck">
                <div class="cuisine-name"> Thursday </div>
              </div>
              <div id="thursdayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurOpenHH" name="thurOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurOpenMM" name="thurOpenMM" />
                <select class="time-selectOption" [(ngModel)]="thurOpenMead" name="thurOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="thursdayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurCloseHH" name="thurCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurCloseMM" name="thurCloseMM" />
                <select class="time-selectOption" [(ngModel)]="thurCloseMead" name="thurCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <div class="clear-copyDiv">
                  <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                    *ngIf="tursdayClearCondition">Clear</span>
                  <div
                    *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0   "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('thur')">
                    Copy
                  </button>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('fridayTime',$event.target)" [checked]="friPrecheck">
                <div class="cuisine-name"> Friday </div>
              </div>
              <div id="fridayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friOpenHH" name="friOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friOpenMM" name="friOpenMM" />
                <select class="time-selectOption" [(ngModel)]="friOpenMead" name="friOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="fridayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH" name="friCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friCloseMM" />
                <select class="time-selectOption" [(ngModel)]="friCloseMead" name="friCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>

                <div class="clear-copyDiv">
                  <span (click)="timeClear('fridayTime')" class="clear-timeBtn" *ngIf="fridayClearCondition">Clear</span>
                  <div
                    *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0   "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('fri')">
                    Copy
                  </button>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="satPrecheck">
                <div class="cuisine-name"> Saturday </div>
              </div>
              <div id="saturdayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satOpenHH" name="satOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satOpenMM" name="satOpenMM" />
                <select class="time-selectOption" [(ngModel)]="satOpenMead" name="satOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="saturdayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH" name="satCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM" name="satCloseMM" />
                <select class="time-selectOption" [(ngModel)]="satCloseMead" name="satCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <div class="clear-copyDiv">
                  <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                    *ngIf="saturdayClearCondition">Clear</span>
                  <div
                    *ngIf="saturdayClearCondition && friOpenHH.length != 0 && friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="saturdayClearCondition && friOpenHH.length != 0 &&friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0   "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sat')">
                    Copy
                  </button>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('sundayTime',$event.target)" [(checked)]="sunPrecheck">
                <div class="cuisine-name"> Sunday </div>
              </div>
              <div id="sundayTimeOpen">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunOpenHH" name="sunOpenHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunOpenMM" name="sunOpenMM" />
                <select class="time-selectOption" [(ngModel)]="sunOpenMead" name="sunOpenMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>
              <div id="sundayTimeClose">
                <input name="" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH" name="sunCloseHH" />
                <span>:</span>
                <input name="somename" class="time-input"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                  type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM" name="sunCloseMM" />
                <select class="time-selectOption" [(ngModel)]="sunCloseMead" name="sunCloseMead">
                  <option value="am" selected>AM</option>
                  <option value="pm">PM</option>
                </select>
                <div class="clear-copyDiv">
                  <span (click)="timeClear('sundayTime')" class="clear-timeBtn" *ngIf="sundayClearCondition">Clear</span>
                  <div
                    *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0">
                    |</div>
                  <button
                    *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0   "
                    mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                    [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                    aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sun')">
                    Copy
                  </button>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="input-container">
          <label for="">Special offers on specific days</label>
          <div class="time-text">Select days</div>
          <div style="margin-left: 15px;">
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('mon',$event.target)" [(checked)]="offerMonday">
                <div class="cuisine-name"> Monday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerMonday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerMonValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerMonday" [(ngModel)]="offerMonValue">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('tue',$event.target)" [(checked)]="offerTuesday">
                <div class="cuisine-name"> Tuesday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerTuesday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerTueValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerTuesday" [(ngModel)]="offerTueValue">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('wed',$event.target)" [(checked)]="offerWednesday">
                <div class="cuisine-name"> Wednesday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerWednesday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerWedValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerWednesday" [(ngModel)]="offerWedValue">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('thu',$event.target)" [(checked)]="offerTurusday">
                <div class="cuisine-name"> Thursday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerTurusday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerThurValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerTurusday" [(ngModel)]="offerThurValue">
              </div>

            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('fri',$event.target)" [(checked)]="offerFriday">
                <div class="cuisine-name"> Friday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerFriday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerFriValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerFriday" [(ngModel)]="offerFriValue">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('sat',$event.target)" [(checked)]="offerSaturday">
                <div class="cuisine-name"> Saturday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerSaturday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerSatValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerSaturday" [(ngModel)]="offerSatValue">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="offerHandelFunc('sun',$event.target)" [(checked)]="offerSunday">
                <div class="cuisine-name"> Sunday </div>
              </div>
              <div class="offer-sub-div">
                <!-- <div class="offer-div" *ngIf="offerSunday">Offer Discount (%)</div> -->
                <input type="text" placeholder="Description of special event/discount" name="offerSunValue" id="" class="form-control" style="width: 55%;"
                  *ngIf="offerSunday" [(ngModel)]="offerSunValue">
              </div>
            </div>
          </div>
        </div>
        <div class="input-container">
          <label for="">Appropriate food allergy message</label>
          <div style="margin-left: 15px;">
            <div style="margin-bottom: 15px;">
              <input type="radio" name="allergenMsg" id="" value="a" class="form-radio form-check-input"
                (change)="queAns = 'A'" [checked]="preRadioSelect('A')">
              <span class="cuisine-name" style="display: block;">a. Currently we cannot provide an allergen free
                preparation in our
                kitchen.</span>
            </div>
            <div style="margin-bottom: 15px;">
              <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'B'"
                [checked]="preRadioSelect('B')">
              <span class="cuisine-name" style="display: block;">b. We strive hard to cater to some food allergies
                or
                intolerances if our
                customers
                communicate specific allergies or intolerances to us before placing the order
                but cannot guarntee allergen free dishes.</span>
            </div>
            <div style="margin-bottom: 15px;">
              <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'C'"
                [checked]="preRadioSelect('C')">
              <span class="cuisine-name" style="display: block;">c. We cater to some food allergies and are
                committed
                avoid cross contamination
                in our kitchen.</span>
            </div>
            <div style="margin-bottom: 15px;">
              <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'D'"
                [checked]="preRadioSelect('D')">
              <span class="cuisine-name" style="display: block;">d. Other</span>
              <textarea name="appropriateFoodAllergyMessage" placeholder="Please give appropriate food allergy message" *ngIf="queAns == 'D'" class="form-control" style="margin-top: 25px;" [(ngModel)]="queAnsOtherText"></textarea>
            </div>
          </div>
        </div>
        <div class="input-container">
          <label for="">Delivary Partner</label>
          <div style="margin-left: 15px;">
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="delevryHandelFunc('deliveroo', $event.target)" [(checked)]="delverooCon"
                  style="margin-top: 16px;">
                <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/delivero-icon.png"
                    alt="" srcset="" style="max-width: 65px;"> Deliveroo </div>
              </div>
              <div class="offer-sub-div" *ngIf="delverooCon">
                <input type="url" name="delverooVal" id="" class="form-control"
                  style="width: 200px; margin: auto 0;" [(ngModel)]="delverooVal"
                  placeholder="Please give the link">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="delevryHandelFunc('justEat', $event.target)" [(checked)]="justEatCon"
                  style="margin-top: 16px;">
                <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/just-eat-icon.png"
                    alt="" srcset="" style="max-width: 65px;"> JustEat </div>
              </div>
              <div class="offer-sub-div" *ngIf="justEatCon">
                <input type="url" name="justEatVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                  [(ngModel)]="justEatVal" placeholder="Please give the link">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="delevryHandelFunc('uberEats', $event.target)" [(checked)]="uberEatsCon"
                  style="margin-top: 16px;">
                <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/uber-eats-icon.png"
                    alt="" srcset="" style="width:65px;"> Uber Eats </div>
              </div>
              <div class="offer-sub-div" *ngIf="uberEatsCon">
                <input type="url" name="uberEatsVal" id="" class="form-control"
                  style="width: 200px; margin: auto 0;" [(ngModel)]="uberEatsVal"
                  placeholder="Please give the link">
              </div>
            </div>
            <div class="offer-main-div">
              <div class="offer-sub-div">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="delevryHandelFunc('foodstuff', $event.target)" [(checked)]="foodstuffCon"
                  style="margin-top: 16px;">
                <div class="cuisine-name" style="margin-top: 0;"> <img
                    src="../../../assets/img/foodstuff-removebg-preview.png" alt="" srcset=""
                    style="max-width: 65px;">
                  Foodstuff </div>
              </div>
              <div class="offer-sub-div" *ngIf="foodstuffCon">
                <input type="url" name="foodstuffVal" id="" class="form-control"
                  style="width: 200px; margin: auto 0;" [(ngModel)]="foodstuffVal"
                  placeholder="Please give the link">
              </div>
            </div>
          </div>
        
        </div>
        <div class="input-container">
          <label for="">Social Links</label>
          <div style="margin-left: 15px;">
              <div class="offer-main-div">
                  <div class="offer-sub-div">
                      <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                          (change)="socialLinkHandelFunc('instagram', $event.target)" [(checked)]="instagramCon">
                      <div class="cuisine-name" style="margin-top: 0;"> <img
                              src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset=""
                              style="max-width: 65px;"> Instagram </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="instagramCon">
                      <input type="url" name="instagramVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                          [(ngModel)]="instagramVal" placeholder="Please give the link">
                  </div>
              </div>
              <div class="offer-main-div">
                  <div class="offer-sub-div">
                      <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                          (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon">
                      <div class="cuisine-name" style="margin-top: 0;"> <img
                              src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                              style="max-width: 65px;"> Facebook </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="facebookCon">
                      <input type="url" name="facebookVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                          [(ngModel)]="facebookVal" placeholder="Please give the link">
                  </div>
              </div>
              <div class="offer-main-div">
                  <div class="offer-sub-div">
                      <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                          (change)="socialLinkHandelFunc('googleMap', $event.target)" [(checked)]="googleMapCon">
                      <div class="cuisine-name" style="margin-top: 0;"> <img
                              src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;"> Google Map </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="googleMapCon">
                      <input type="url" name="googleMapVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                          [(ngModel)]="googleMapVal" placeholder="Please give the link">
                  </div>
              </div>
          </div>
      
        </div>
        <div class="input-container">

          <label>Menu (image should be less than 500kb)</label>
          <div *ngIf="menuSrc.length != 0" class="menu-img-preview-main">
            <div *ngFor="let item of menuSrc; let i =index"
              style="width: 30%;margin-right: 10px; margin-bottom: 20px;display: flex;align-items: flex-start;">
              <img [src]="item.src" alt="menu img">
              <img src="../../../assets/images/Cancel.png" alt=""
                style="position: relative; top: -6px;right: 14px; cursor: pointer;" (click)="menuImgDelete(i,item)">
            </div>
            <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
              <input type="file" accept="image/png,image/jpeg,application/pdf"
                (change)="onMenuChange($event,'menuImgDelete1')" #fileInput_Menu_image hidden name="imgFile"
                id="menuImgDelete1" />
              <img src="../../../assets/images/upLogo.png" alt="">
              <span>Add file</span>
            </div>
          </div>
          <div *ngIf="pdfMenuSrc != 'null' && menuSrc.length == 0 ">
            <span class="pdfMainSpan">
              <img src="../../../assets/img/pdf-icon.png" alt="" (click)="openpdf()">
              <span style="overflow-wrap: anywhere; margin: auto 0;" (click)="openpdf()">{{pdfMenuSrc}}</span>
              <img src="../../../assets/img/close-red-icon.png" alt=""
                style="width: 17px;height: 17px;margin:auto 0; cursor:pointer" (click)="pdfDelete()">
            </span>
          </div>
          <div class="menu-first-div" *ngIf="menuSrc.length == 0 && pdfMenuSrc == 'null'">
            <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
              <input type="file" accept="image/png,image/jpeg,application/pdf"
                (change)="onMenuChange($event,'menuImgDelete2')" #fileInput_Menu_image hidden name="imgFile"
                id="menuImgDelete2" />
              <img src="../../../assets/images/upLogo.png" alt="">
              <span>Add file</span>
            </div>
            <!-- <div>or</div>
                <div class="addBtn-mainDiv" (click)="menuLinkInsert()">
                    <img src="../../../assets/images/insert.png" alt="">
                    <span>Insert link</span>
                </div> -->

          </div>
          <div *ngIf="menuLinkCondition">
            <div style="font-size: 16px; line-height: 23px; color: #737373;">Please enter the link</div>
            <input type="url" name="" id="" class="form-control" style="width: 50%;" spellcheck="false">
          </div>

        </div>
        <div class="input-container">
          <label for="">Please add any other description or tags that are associated and relevant to your Food
            business separated by commas.</label>
          <textarea name="otherDescriptionOrTags" id="" cols="30" rows="10"
            placeholder="Example: Pool table, Board games, Proper pub, Nice Wine collection, Wine and Cheese, etc"
            class="form-control" style="height:100px" [(ngModel)]="otherDescriptionOrTags"></textarea>

        </div>
        <div class="flex buttomPartAddResto">
          <!-- <div class="common closeBtn" (click)="closeEditFunc()">Close</div> -->
          <div class="common submitBtn" (click)="submitEditRestoCreate(editResto)">Update</div>
        </div>
      </form>
    </div>
  </div>
</div>